import { type ReactNode } from 'react';

const INPUT_CLS =
  'w-full rounded-md border border-white/[0.08] bg-surface px-3 py-2 text-center text-sm text-text-primary placeholder:text-text-tertiary focus:border-brand-red focus:outline-none focus:ring-2 focus:ring-brand-red/30 disabled:cursor-not-allowed disabled:opacity-40';
const READ_CLS =
  'w-full rounded-md border border-border-subtle bg-white/[0.02] px-3 py-2 text-center text-sm text-text-secondary';

type Props = {
  value: string;
  disabled?: boolean;
  locked?: boolean;
  onChange: (v: string) => void;
  error: string;
};

function ReadOnly({ value }: { value: string }): ReactNode {
  return (
    <div className="flex w-full flex-col items-center gap-xs">
      <p className={READ_CLS}>@{value}</p>
    </div>
  );
}

type EditableProps = {
  value: string;
  disabled: boolean;
  onChange: (v: string) => void;
  error: string;
};

function Editable(p: EditableProps): ReactNode {
  return (
    <div className="flex w-full flex-col items-center gap-xs">
      <input
        type="text"
        value={p.value}
        onChange={(e) => p.onChange(e.target.value)}
        disabled={p.disabled}
        placeholder="ej. @marta.lopez_"
        autoCapitalize="none"
        autoCorrect="off"
        spellCheck={false}
        className={INPUT_CLS}
      />
      {p.error && <p className="text-xs text-error">{p.error}</p>}
    </div>
  );
}

export function IgUsernameInput(p: Props): ReactNode {
  if (p.locked) return <ReadOnly value={p.value} />;
  return (
    <Editable
      value={p.value}
      onChange={p.onChange}
      error={p.error}
      disabled={p.disabled ?? false}
    />
  );
}
